import React from 'react'
import { LeftSideColor, SingleItemBold } from '../../UI/TableItem'
import moment from 'moment'
import styled from '@emotion/styled'
import { TicketType } from 'Tickets/dummy-data'

type TicketItemProps = {
  ticket: TicketType
  index: number
}

const StyledTr = styled.tr`
  border-left: ${({ color }) => `5px solid ${color}`};
`

const TicketItem: React.FC<TicketItemProps> = ({ ticket, index }) => {
  const color = LeftSideColor(index)

  return (
    <StyledTr className="tableRowHover" key={index} color={color.color}>
      <SingleItemBold text={moment(ticket.date).format('MM/DD/YYYY HH:mm')} />
      <SingleItemBold text={ticket.ticketNumber} />
      <SingleItemBold text={ticket.project} />
      <SingleItemBold text={ticket.dotdJMF} />
      <SingleItemBold text={ticket.type} />
      <SingleItemBold text={ticket.lot} />
      <SingleItemBold text={String(ticket.temp)} />
      <SingleItemBold text={String(ticket.quantity)} />
      <SingleItemBold text={String(ticket.totalShipped)} />
      <SingleItemBold text={String(ticket.truckId)} />
    </StyledTr>
  )
}

export default TicketItem
